var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tickets',{attrs:{"userType":"admin"}})
}
var staticRenderFns = []

export { render, staticRenderFns }